import React, { useState, useEffect } from 'react';

export const TimeRangeDropdownAlt3 = ({ value, onChange, chartId }) => {
	const currentYear = new Date().getFullYear();
	const years = Array.from({ length: currentYear - 2019 }, (_, i) => currentYear - i);

	const [isYearMode, setIsYearMode] = useState(false);
	const [year, setYear] = useState(currentYear.toString());

	useEffect(() => {
		if (isYearMode) onChange(year, chartId);
	}, [isYearMode]);

	const handleMainChange = e => {
		const val = e.target.value;
		if (val === 'select-year') {
			setIsYearMode(true);
			setYear(currentYear.toString());
		} else {
			setIsYearMode(false);
			onChange(val, chartId);
		}
	};

	const handleYearChange = e => {
		const selected = e.target.value;
		setYear(selected);
		onChange(selected, chartId);
	};

	return (
		<div className="d-flex align-items-center gap-4" style={{ marginBottom: '10px' }}>
			<div>
				{isYearMode && (
					<select
						value={year}
						onChange={handleYearChange}
						className="form-control form-control-sm rounded"
						style={{ width: '120px', borderRadius: '50px' }}
					>
						{years.map(yr => (
							<option key={yr} value={yr}>
								{yr}
							</option>
						))}
					</select>
				)}
			</div>

			<select
				value={isYearMode ? 'select-year' : value}
				onChange={handleMainChange}
				className="form-control form-control-sm rounded"
				style={{ width: '160px', borderRadius: '50px' }}
			>
				<option value="today">Today</option>
				<option value="pastWeek">Past Week</option>
				<option value="past30Days">Past 30 Days</option>
				<option value="lastMonth">Last Month</option>
				<option value="pastQuarter">Past Quarter</option>
				<option value="pastSixMonths">Past Six Months</option>
				<option value="pastYear">Past Year</option>
				<option value="lastYear">Last Year</option>
				<option value="pastThreeYears">Past Three Years</option>
				<option value="select-year">Select Year</option>
				<option value="allTime">All Time</option>
			</select>
		</div>
	);
};
